module.exports = __webpack_public_path__ + "static/img/logo_blue.3c9cc0ff.png";